import React, { createContext, useContext, useState, ReactNode } from 'react';

interface Subject {
  id: string;
  name: string;
  icon?: string;
  color?: string;
}

interface DashboardContextType {
  selectedSubject: Subject | null;
  setSelectedSubject: (subject: Subject | null) => void;
  isChatMode: boolean;
  setIsChatMode: (isChat: boolean) => void;
}

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export function DashboardProvider({ children }: { children: ReactNode }) {
  const [selectedSubject, setSelectedSubject] = useState<Subject | null>(null);
  const [isChatMode, setIsChatMode] = useState(false);

  return (
    <DashboardContext.Provider value={{
      selectedSubject,
      setSelectedSubject,
      isChatMode,
      setIsChatMode
    }}>
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashboard() {
  const context = useContext(DashboardContext);
  if (context === undefined) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
}
